module.exports = __webpack_public_path__ + "img/machine2.af15801f.png";